import ReviewCard from './ReviewCard.component';

export default ReviewCard;
